
{
  "fr": {
    "configuratorLayerEditorModalEdit": {
      "actions": {
        "updateImage": "Changer d'image",
        "text-next": "Valider le texte",
        "ai-editing": "Modifier avec IA",
        "image-next": "Valider l'image",
        "removeText": "Annuler"
      }
    }
  }
}
